import { icon } from '@fortawesome/fontawesome-svg-core';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import $ from 'jquery';
import bootbox from 'bootbox';
import escapeHtml from 'escape-html';

// Import for bootbox popups.
import 'bootstrap/js/dist/modal';
$("html").on("click", "a", function () {
  var link = this;
  var leavingSite = true;

  // Ignore javascript and mailto links.
  var exemptProtocols = ["mailto:", "javascript:"];
  if ($.inArray(link.protocol, exemptProtocols) != -1) {
    leavingSite = false;
  } else if (!link.hostname) {
    leavingSite = false;
  } else if (link.hostname) {
    // Check the simplest, quickest case of the links hostname being the
    // same as the current page's hostname.
    if (link.hostname == window.location.hostname) {
      leavingSite = false;
    } else {
      // Determine the base hostname of the link (eg, just "energy.gov" for
      // "www.afdc.energy.gov").
      var hostnameParts = link.hostname.split(".");
      var baseHostname = hostnameParts[hostnameParts.length - 2] + "." + hostnameParts[hostnameParts.length - 1];
      baseHostname = baseHostname.toLowerCase();

      // See if the base hostname is in a whitelist of "internal" sites.
      var internalSites = ["energy.gov", "doe.gov", "energysavers.gov", "energycodes.gov", "loseyourexcuse.gov", "solardecathlon.gov", "windpoweringamerica.gov", "save-energy-now.org", "fueleconomy.gov", "youtube.com", "cleancities.org", "litmos.com", "cleancitiessharepoint.org"];
      if ($.inArray(baseHostname, internalSites) != -1) {
        leavingSite = false;
      }
    }
  }
  if (leavingSite) {
    // Allow the warning to be disabled if the
    // "disable-external-link-warning" data attribute element is present.
    var $link = $(link);
    if ($link.data("disable-external-link-warning") == true) {
      leavingSite = false;
    }
  }
  if (leavingSite) {
    var href = link.href;
    var escapedHref = escapeHtml(href);
    var content = '<p>Click "Continue" to proceed to the following website or "Cancel" to stay here.</p>';
    content += '<p><a href="' + escapedHref + '" data-disable-external-link-warning="true">' + escapedHref + '</a></p>';
    var buttons = [{
      label: `Continue ${icon(faChevronRight).html}`,
      className: "btn-primary order-2",
      callback: function () {
        window.location = href;
      }
    }, {
      label: `${icon(faChevronLeft).html} Cancel`,
      className: "btn-default order-1"
    }];
    try {
      bootbox.dialog({
        message: content,
        title: "You are leaving a U.S. Department of Energy website.",
        buttons: buttons,
        animate: false,
        onEscape: true,
        backdrop: true,
        className: 'leaving-site-modal'
      });
    } catch (e) {
      console.log("Error: %o", e); // eslint-disable-line no-console
    }

    return false;
  } else {
    return true;
  }
});